<ng-template #deleteModal>
  <div class="card deletePopup" [ngClass]="{'store-delete-popup':(isStoreDelete || isSystemIDContent)}" dir={{direction}}>
    <div class="modal-header">
      <div *ngIf="!isStoreDelete" (click)="dismiss()" class="close_icon">
        <img src="assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div class="modal-body popup-body" [ngClass]="{'popUpWidth': popupHeader ? true : false }">
      <h2 *ngIf="popupHeader"><span>{{popupHeader}}</span></h2>
      <h2 *ngIf="!isStoreDelete && !popupHeader &&!isSkuIdAll && !isSystemIDContent"><span i18n="@@delete-popup.delete-header-text">Delete {{contentName}}?</span></h2>
      <h2 *ngIf="isSkuIdAll" class="sku_Id_all" ><span i18n="@@delete-popup.confirmation-popup.selected-skus">{{(tabbIndex.length > 1) ? globalconst.DELETE_SKU_TEXT : deleteSelectedSku}}</span></h2>
      <h2 *ngIf="isStoreDelete || (isSystemIDContent && isMultisystemIddelete)"><span i18n="@@delete-popup.are-you-sure-confirm-msg">Are you sure you want to delete {{contentName}}?</span></h2>
      <h2 *ngIf="isSystemIDContent && !isMultisystemIddelete"><span>Are you sure you want to delete the  selected IDs?</span></h2>
      <div class="card_desc" *ngIf="!isPartnerContent && !isAttractLoop && !isSkuIdContent && !isSkuIdAll && !isStoreDelete && !popupHeader && !isSystemIDContent">
        <span i18n="@@delete-popup.desc">This change may apply to all profiles and devices using this
          information.</span>
      </div>
      <div class="card_desc" *ngIf="isSystemIDContent">
        <span>Deleting System ID will delete the corresponding System Models and assets associated with them.</span>
      </div>
      <div class="card_desc" *ngIf="isSkuIdAll">
        <span i18n="@@delete-popup.desc">{{(tabbIndex.length > 1) ? '' : 'This change may apply to all profiles and devices using this
          information.'}}</span>
      </div>
      <div class="card_desc" *ngIf="isSkuIdContent && !isSkuIdAll">
        <span i18n="@@delete-popup.changes-to-all.profiles">This change may apply to all profiles using this information.</span>
      </div>
      <div class="card_desc" *ngIf="isSkuIdAll">
        <span > </span>
      </div>
     
      <div class="card_desc" *ngIf="isPartnerContent">
        <span i18n="@@delete-popup.partner-content.desc">This Content Group will be permanently deleted.</span>
      </div>
      <div class="card_desc" *ngIf="isAttractLoop">
        <span i18n="@@delete-popup.attract-loop-content.desc">This content will be permanently deleted.</span>
      </div>
       <div class="card_desc" *ngIf="isStoreDelete && isStoreContent">
        <span i18n="@@delete-popup.stores-delete-msg">All the users and devices associated to the stores, as well as assets and packages associated to these stores will be permanently deleted.</span>
      </div>
      <div class="card_desc" *ngIf="bodyContent">
        <span [innerHTML]="bodyContent"></span>
      </div>
    </div>
    <div class="modal-footer card-footer popup-footer" [ngClass]="{'card-store-footer':isStoreDelete}">
      <button type="button" (click)="dismiss()" class="btn btn-outline-primary gtmCancelDltContGrp cancel-btn">
        <span i18n="@@delete-popup.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary gtmDeleteContGrp delete-btn" (click)="deleteContent()">
        <span i18n="@@delete-popup.delete-button-text">Delete {{buttonName}}</span>
      </button>
    </div>
  </div>
</ng-template>